
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(2(13|2|3)|3(68|74|88)|(0|44|64)1|088|120|139|873)|2((03|38|44)6|110|244|280|333|658|782|92)|5(9(07|18|47)|56[08]|7(14|36|76)|034|148|228|274|853)|6(3(09|82|94)|[78]57|418)|1(9(23|60|84)|2(07|33|64|88)|(50|58|84)2|424|696|839)|8(4(52|80|86)|007|065|98|990)|7((03|34|46)0|(01|18|56)7|332|539|681|804|896|911|936)|3(4(05|57|67)|224|266|346|589|72|785|975|994)|9(8(08|15|61)|180|288|431|475|724))$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
